// extracted by mini-css-extract-plugin
export var container = "_gj-1";
export var editor = "_gj-2";
export var resizable = "_gj-3";
export var wrapper = "_gj-0";